<template>
  <el-dialog
    :visible.sync="uploadxufei"
    width="600px"
    title="批量短信"
  >
    <div class="uploadxufei">
      <el-steps class="upload_steps" :active="active" finish-status="success">
        <el-step :title="excelFile?excelFile.name:'上传文件'"></el-step>
        <el-step title="发送短信下发"></el-step>
        <el-step :title="status"></el-step>
      </el-steps>
      <el-radio-group class="radio_up" v-model="radio">
        <el-radio label="<CKBSJ>">查询参数</el-radio>
        <el-radio label="<CKVER>">查询版本</el-radio>
        <el-radio label="<SPBSJ*P:BSJGPS*T:219.133.034.198,7788*U:000.000.000.000,0000*A:CMNET*N:13418181818>">设置终端参数</el-radio>
      </el-radio-group>
      <el-input type="text" v-model="radio" size="small" placeholder="请填写内容" />
      <div class="overflow">
        <el-upload
            action=""
            class="upload_file"
            :http-request="({ file }) => (excelFile = file)"
            :show-file-list="false"
            :on-change="onChange"
          >
          <div
          class="el-upload__text"
          v-html="`<el-button style='color:#FFF;background:#4B88F6;padding:6px 16px;line-height:34px;' type='primary'>上传文件</el-button>`"
          ></div>
        </el-upload>
        <el-button class="fl" size="small" type="primary" @click="downloadtemplate">下载模板</el-button>
        <el-button  class="fl" size="small" type="primary" @click="renewFn">确认短信下发</el-button>
        <el-button class="fl" size="small" type="primary" @click="empty">清空</el-button>
        <el-upload
            action=""
            class="upload_file"
            style="width:140px"
            :http-request="({ file }) => (excelFile2 = file)"
            :show-file-list="false"
            :on-change="downloadFn"
          >
          <div
          class="el-upload__text"
          style="width:140px;text-align:left;"
          v-html="`<el-button style='color:#FFF;background:#4B88F6;padding:6px 12px;line-height:34px;margin:0 10px;width:100%' type='primary'>
            ${loading?'回复查询中':'下载回复'}</el-button>`"
          ></div>
        </el-upload>
      </div>
      <div class="does_not_belong" v-if="prompt">
        <h2>提示：</h2>
        <p>
          {{prompt}}
        </p>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { AxiosTime } from "@/api/apiFn";
export default {
  data(){
    return {
      uploadxufei:false,
      active:0,
      excelFile:null,
      status:'未下发',
      num:0,//轮询次数
      radio:'<CKBSJ>',
      contentId:null,
      prompt:'',//提示
      excelFile2:null,
      loading:false,//加载
    }
  },
  watch:{
    uploadxufei:{
      handler(val){
        if(val){
          this.active = 0;
          this.status = '未下发';
          this.contentId = null;
          this.excelFile = null;
          this.radio = '<CKBSJ>';
          this.prompt = '';
          this.excelFile2 = null;
        }
      },
      deep:true,
    }
  },
  computed:{
    //获取IP地址
    ip(){
      return process.env.NODE_ENV === 'development'?`${window.location.protocol}//192.168.100.179:80`:`${window.location.protocol}//${window.location.host}`;
      // return 'https://sw.car900.com/';
    },
  },
  methods:{
    //选择文件
    onChange(){
      this.active = 1;
      this.prompt = '';
    },
    //下载短信回复
    downloadFn(){
      this.loading = true;
      setTimeout(()=>{
        let formData = new FormData();
        formData.append('file',this.excelFile2);
        console.log(this.excelFile2)
        AxiosTime(`${this.ip}/excel/uploadMessageBySimCardExcel.json`,formData).then(res=>{
          this.loading = false;
          if(res.data.code == 0){
            window.open(`/operator/getBatchSingleRecord2Excel.json?contentId=${res.data.data}&sessionId=${this.$store.state.LOGINUSER.sid}`);
          }else{
            this.$message({
              type:'warning',
              message:res.data.data == null?res.data.msg:res.data.data + '非该账号卡号不能查询'
            })
          }
        }).catch(error=>{
          console.log(error)
        })
      },1000)
      // if(!this.contentId) return;
      
    },
    //下载模板
    downloadtemplate(){
      window.open('/staticFile/sendMessage.xlsx');
    },
    //轮询短信下发状态
    pollingStatus(){
      let num = 0;
      let time = setInterval(()=>{
        this.$API.getSendSmsStatusByContentId({contentId:this.contentId}).then(res=>{
          if(num >= 60){
            clearInterval(time);
          }
          console.log(res.data)
          if(res.data.length){
            clearInterval(time);
            num++;
            this.active = 3;
            this.status = '下发成功';
          }
        }).catch(error=>{
          console.log(error);
        })
      },1000);
      
    },
    //短信下发
    renewFn(){
      if(!this.excelFile){
        this.$message({
          type:'warning',
          message:'请先上传文件'
        })
        return;
      }
      this.active = 2;
      this.status = '下发中';
      let formData = new FormData();
      formData.append('file',this.excelFile);
      formData.append('content',this.radio);
      AxiosTime(`${this.ip}/operator/uploadSendMessageByExcel.json`,formData).then(res=>{
        this.$message({
          type:res.data.code == 0?"success":"warning",
          message:res.data.msg
        })
        if(res.data.code == 0){
          this.contentId = res.data.data;
          this.pollingStatus();
        }else{
          this.prompt = `${res.data.msg}：${res.data.data}`;
        }
      }).catch(error=>{
        console.log(error)
      })
    },
    //上传
    uploadFn(){
      this.active = 3;
    },
    //清空队列
    empty(){
      this.active = 0;
      this.excelFile = null;
      this.contentId = null;
      this.prompt = '';
      this.radio = '<CKBSJ>';
      this.excelFile2 = null;
    },
  },
}
</script>
<style>
.uploadxufei .el-step__title{
  font-size: 12px;
}
.uploadxufei .upload_file{
  float: left;
  width: 100px;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
.fl{
  float: left;
}
.fr{
  float: right;
}
.overflow{
  overflow: hidden;
}
.upload_steps{
  margin-bottom: 20px;
}
.does_not_belong{
  margin: 20px 0;
  >h2{
    color:#333;
    font-size: 18px;
    margin-bottom: 10px;
  }
  >p{
    overflow:hidden;
    text-overflow: ellipsis;
    word-wrap:break-word;
    line-height: 26px;
    color:#666;
  }
}
.uploadxufei{
  /deep/input{
    width: 80%;
    margin-bottom: 20px;
  }
}
/deep/.radio_up{
  margin-bottom: 20px;
}
</style>